module.exports = __webpack_public_path__ + "static/media/apiflor-ok.90957db3.jpg";